<template>
  <div>
    <TheMobileHeader
      title="Hotel Results"
      :showHelpIcon="false"
      showBack
      showItinerary
      @back="onBack"
    />

    <MobileHotelMapView />
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router'
import { useHead } from '@unhead/vue'
import { useI18n } from 'vue-i18n'
import MobileHotelMapView from '../components/HotelResults/MobileHotelMapView/MobileHotelMapView.vue'
import TheMobileHeader from '@/modules/Core/components/layout/MobileHeader/TheMobileHeader.vue'

const { t } = useI18n()
useHead({
  titleTemplate: (title) => `${title} - ${t('search.exploreOnMap')}`,
})

const router = useRouter()

function onBack() {
  router.push({ name: 'Result' })
}
</script>
